/*jshint esversion: 6 */

let timeOutscrollToTop = 0;

function scrollToTop() {
    
    if (document.body.scrollTop !== 0 || document.documentElement.scrollTop !== 0){
        window.scrollBy(0, -100);
        timeOutscrollToTop = setTimeout(scrollToTop, 10);
    }
    else {
        clearTimeout(timeOutscrollToTop);
    }
}

/*** --- Desktop version ---***/
export default function() {
    
    if (window.innerWidth > 768) {
        
        let navMenu = document.getElementById('navmenutop'),
            header = document.getElementById('toplineheader'),
            // lastScrollTop = 0,
            // pageYOffseter = 0,
            scrollToTopButton = document.getElementById('myScroll'),
            scrollToTopOut = document.getElementById('myScrollOut');
        
        window.onscroll = function() {
            
            // top menu:
            /* pageYOffseter = window.pageYOffset || document.documentElement.scrollTop;
            
            if ( document.documentElement.scrollTop > header.scrollTop + 350 && pageYOffseter < lastScrollTop ) {
                // console.log(document.documentElement.scrollTop - header.scrollTop);
                
                navMenu.classList.add('animated');
                navMenu.classList.add('fadeIn');
                navMenu.classList.add("is-fixed-top");
                navMenu.classList.remove("is-spaced");
            } else {
                // this.console.log();
                navMenu.classList.remove('animated');
                navMenu.classList.remove('fadeIn');
                navMenu.classList.remove("is-fixed-top");    
                navMenu.classList.add("is-spaced");    
            }
            
            lastScrollTop = pageYOffseter <= 0 ? 0 : pageYOffseter; */
            
            // scroll top button
            if (document.documentElement.scrollTop > 400) {
                // console.log(document.documentElement.scrollTop);
                scrollToTopOut.style.display = "block";
                scrollToTopOut.classList.add('animated');
                scrollToTopOut.classList.add('fadeIn');                   
                // scrollToTopButton.classList.add('is-primary');                   
                // scrollToTopButton.classList.add('is-outlined');                   
            } else {
                scrollToTopOut.style.display = "none";
                scrollToTopOut.classList.remove('animated');
                scrollToTopOut.classList.remove('fadeIn');
                // scrollToTopButton.classList.remove('is-primary');                   
                // scrollToTopButton.classList.remove('is-outlined');    
            }
            
        };
        
        scrollToTopButton.onclick = scrollToTop;
    }
    
}
